import { Twilio, Room, LocalTrack, LocalVideoTrack, LocalAudioTrack, RemoteParticipant, LocalParticipant } from 'twilio-video';
import { Component, ViewChild, OnInit, Input } from '@angular/core';
import { CameraComponent } from '../camera/camera.component';
import { SettingsComponent } from '../settings/settings.component';
import { ParticipantsComponent } from '../participants/participants.component';
import { VideoChatService } from '../services/videochat.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { VproService } from 'src/app/service/vpro/vpro.service';
import Swal from 'sweetalert2';
import { Utils } from "src/app/common/utils";
const Toast = Swal.mixin({
  toast: true,
  position: "top",
  showConfirmButton: false
});

@Component({
  selector: 'app-home',
  styleUrls: ['./home.component.css'],
  templateUrl: './home.component.html',
})
export class VedioHomeComponent implements OnInit {
  @ViewChild('camera') camera: CameraComponent;
  @ViewChild('camera1') camera1: CameraComponent;
  @ViewChild('settings') settings: SettingsComponent;
  @ViewChild('participants') participants: ParticipantsComponent;

  Video = require('twilio-video');
  videoInfo: MediaDeviceInfo;
  @Input() aptid = null;
  @Input() role = null;
  @Input() isMinimize = false;
  activeRoom: Room;
  public deviceId: any;
  public devices: any[] = [];
  isMute: boolean = false;
  vedioOff: boolean = false;
  videoCall: boolean = false;
  homePageUrl = Utils.homePageUrl;
  videoTrack1: LocalVideoTrack;
  isEventFired: boolean = false;
  constructor(
    private readonly videoChatService: VideoChatService,
    private spinner: NgxSpinnerService,
    private service: VproService) { }

  async ngOnInit() {
    this.getAppointment();


    // if (!this.activeRoom && !this.isMinimize) {
    //   this.joinRoom();
    // }


  }

  async onSettingsChanged(deviceInfo: MediaDeviceInfo) {
    await this.camera.initializePreview(deviceInfo);
  }

  async onLeaveRoom(_: boolean) {
    this.disconnectRoom();
    this.camera.finalizePreview();
    this.camera.initializePreview()
    this.participants.clear();
  }

  async disconnectRoom() {
    if (this.activeRoom) {
      this.activeRoom.disconnect();
      this.activeRoom = null;
    }
  }

  getAppointment() {
    this.spinner.show();
    this.service.getAppointmentDetails({ aptid: this.aptid }).subscribe(res => {
      this.spinner.hide();
      if (res) {
        let { apttype } = res;
        if (apttype === Utils.APPOINTMENT_TYPE.VIDEO) {
          this.videoCall = true;
        }
        if (apttype === Utils.APPOINTMENT_TYPE.IN_PERSON) {
          this.videoCall = true;
        }
        this.camera.finalizePreview();
        this.camera.handleVideoChanges({ video: this.videoCall, initials: this.role.toUpperCase() })


        setTimeout(x => {
          if (!this.activeRoom && !this.isMinimize) {
            this.joinRoom();
          }
        }, 600)



      }
    }, err => {
      this.spinner.hide();
      console.log(err);
    })
  }

  async onRoomChanged(token: string) {
    if (token) {
      if (this.activeRoom) {
        this.activeRoom.disconnect();
      }

      const tracks = await this.camera.tracks;

      this.activeRoom =
        await this.videoChatService
          .joinOrCreateRoom(token, this.aptid, tracks);
      console.log('active room is', this.activeRoom);
      if (this.activeRoom) {
        this.participants.initialize(this.activeRoom.participants);
        this.registerRoomEvents();
      }


    }
  }

  onParticipantsChanged(_: boolean) {
    this.videoChatService.nudge();
  }

  private registerRoomEvents() {
    this.activeRoom
      .on('disconnected',
        (room: Room) => {
          console.log('room disconnected', room);
          room.localParticipant.tracks.forEach(publication => this.detachLocalTrack(publication.track))
          this.onLeaveRoom(true);
        })
      .on('participantConnected',
        (participant: RemoteParticipant) => {
          console.log('added', participant);
          this.participants.add(participant)
        })
      .on('participantDisconnected',
        (participant: RemoteParticipant) => {
          console.log('removed', participant);
          this.participants.remove(participant)
        })
      .on('dominantSpeakerChanged',
        (dominantSpeaker: RemoteParticipant) => this.participants.loudest(dominantSpeaker));
  }

  private detachLocalTrack(track: LocalTrack) {
    if (this.isDetachable(track)) {
      track.detach().forEach(el => el.remove());
    }
  }

  private isDetachable(track: LocalTrack): track is LocalAudioTrack | LocalVideoTrack {
    return !!track
      && ((track as LocalAudioTrack).detach !== undefined
        || (track as LocalVideoTrack).detach !== undefined);
  }

  gotDevices(mediaDevices: any[]) {
    console.log("media devices", mediaDevices)
    mediaDevices.forEach((mediaDevice: { kind: string; deviceId: string; label: string; }) => {
      if (mediaDevice.kind === 'videoinput') {
        this.devices.push({ deviceId: mediaDevice.deviceId });
      }
    });
    this.devices[0] = { ...this.devices[0], selected: true };
    console.log("devices are ", this.devices)
  }

  switchCamera() {
    if (this.devices.length === 1) {
      return;
    }
    let selectedCamIndex = 0;
    this.devices.forEach((device, index) => {
      if (device && "selected" in device && device.selected === true) {
        selectedCamIndex = index;
        device.selected = false;
      }
    });
    this.updateVideoDevice(selectedCamIndex);
  }

  handleVoice() {
    let that = this;
    this.activeRoom.localParticipant.audioTracks.forEach(function (track) {
      if (that.isMute) {
        track.track.enable();
      } else {
        track.track.disable();
      }
    });
    this.isMute = !this.isMute;
  }

  handleVedio() {
    let that = this;
    this.activeRoom.localParticipant.videoTracks.forEach(function (track) {
      if (that.vedioOff) {
        track.track.enable();
      } else {
        track.track.disable();
      }
    });
    this.vedioOff = !this.vedioOff;
  }

  public async joinRoom() {
    let devices = await navigator.mediaDevices.enumerateDevices();
    this.gotDevices(devices);

    if (!this.isEventFired)
      this.spinner.show();
    this.service.getConferenceToken(this.aptid, this.role).subscribe(res => {
      this.spinner.hide();
      let { token } = res;
      this.onRoomChanged(token);
    }, err => {
      this.spinner.hide();
      console.log(err);
      let message = 'Something went wrong. Please try again!';
      if (err && err.error && err.error.message) message = err.error.message;
      this.showToast('error', message);
    });

  }

  async updateVideoDevice(selectedCamIndex) {
    let select = "";
    selectedCamIndex = selectedCamIndex === 1 ? 0 : 1;
    select = this.devices[selectedCamIndex].deviceId;
    this.devices[selectedCamIndex].selected = true;
    // const select = event;
    this.isEventFired = true;
    const localParticipant = this.activeRoom.localParticipant;

    console.log("local Participant: ", localParticipant, "and event is", event, "video id is", select);
    if (select !== '') {
      let videoTrack = Array.from(localParticipant.videoTracks.values());

      localParticipant.videoTracks.forEach((publication) => {
        publication.unpublish();
      });
      let localTracks = 'videoinput' && select
        ? await this.camera.initializeTracks('videoinput', select)
        : await this.camera.initializeTracks();

      this.videoTrack1 = localTracks.find(t => t.kind === 'video') as LocalVideoTrack;
      console.log("videotrack", this.videoTrack1)
      localParticipant.publishTrack(this.videoTrack1);
      this.activeRoom.LocalParticipant = localParticipant;
      this.camera.initializeDevice('videoinput', select);
    }

  }

  showToast(type, title) {
    Toast.fire({
      type: type,
      title: title
    });
  }
}